import { useEffect } from "react";

/**
 * ref로 지정된 요소 외부를 클릭했을 때 콜백을 실행하는 훅
 * @param {React.RefObject} ref - 감지할 요소의 ref
 * @param {function} handler - 외부 클릭 시 실행할 콜백 함수
 */
export function useClickOutside(ref, handler) {
    useEffect(() => {
        const listener = (event) => {
            // ref.current가 없거나 클릭한 요소를 포함하고 있으면(내부 클릭) 무시
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }

            // 외부 클릭 시 핸들러 실행
            handler(event);
        };

        // mousedown 이벤트 리스너 등록
        document.addEventListener("mousedown", listener);
        // 터치스크린도 지원
        document.addEventListener("touchstart", listener);

        // 컴포넌트 unmount 시 이벤트 리스너 제거
        return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, [ref, handler]); // ref나 handler가 변경될 때만 이펙트 재실행
}
